export const HBO_REGISTRATION_PARAMS = {
  connectClientName: 'HBO',
  worldUrlParameter: { packageid: 'HBO' },
};

export const STREAMING_REGISTRATION_DEFAULTS = HBO_REGISTRATION_PARAMS;

export const DISNEY_REGISTRATION_PARAMS = {
  connectClientName: 'DISNEY',
  worldUrlParameter: { packageid: 'DISPLS' },
};

export const StreamingRegistrationFlowSteps = Object.freeze({
  CHOOSE_FLOW: 'CHOOSE_FLOW',
  EFFECTIVE_ML_GET_REGISTRATION_STATUS: 'EFFECTIVE_ML_GET_REGISTRATION_STATUS',
  REDIRECT_TO_WORLD: 'REDIRECT_TO_WORLD',
  REDIRECT_TO_OFFICIAL_PAGE: 'REDIRECT_TO_OFFICIAL_PAGE',
  CHECK_IF_TV_SERVICE_EXISTS: 'CHECK_IF_TV_SERVICE_EXISTS',
  REDIRECT_TO_NO_TV_SERVICE: 'REDIRECT_TO_NO_TV_SERVICE',
  CHOOSE_TV_SUBSCRIPTION: 'CHOOSE_TV_SUBSCRIPTION',
  EXPIRED_ML_GET_REGISTRATION_STATUS: 'EXPIRED_ML_GET_REGISTRATION_STATUS',
  GET_TOKEN: 'GET_TOKEN',
  PACKAGE_EXIST_GET_TOKEN: 'PACKAGE_EXIST_GET_TOKEN',
  PACKAGE_EXIST_ADD_CHANNEL_GET_TOKEN: 'PACKAGE_EXIST_ADD_CHANNEL_GET_TOKEN',
  PACKAGE_NOT_EXIST_GET_TOKEN: 'PACKAGE_NOT_EXIST_GET_TOKEN',
  ERROR_SCREEN: 'ERROR_SCREEN',
  REDIRECT_TO_STREAMING_LOGIN: "REDIRECT_TO_STREAMING_LOGIN",
});
export const StreamingRegistrationStatus = Object.freeze({
  SubscriberNotFound: 1,
  StreamingChannelNotFound: 2,
  CHA1: 3,
  CHA2: 4,
  CHA3: 5,
  GeneralError: 6,
  ReturningCustomer: 7,
});

export const StreamingRegistrationProcessTypes = Object.freeze({
  ML: 'ML',
  PACKAGE_EXIST: 'PACKAGE_EXIST',
  PACKAGE_EXIST_ADD_CHANNEL: 'PACKAGE_EXIST_ADD_CHANNEL',
  PACKAGE_NOT_EXIST: 'PACKAGE_NOT_EXIST',
});
